const initialState = {
  fetching: false,
};

export default function callSlotReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'ADDING_CALL_SLOT':
      return { ...currentState, fetching: true };
    case 'EDITING_CALL_SLOT':
      return { ...currentState, fetching: true };
    case 'DELETING_CALL_SLOTS':
      return { ...currentState, fetching: true };
    case 'CALL_SLOT_ADDED':
      return { ...currentState, fetching: false };
    case 'CALL_SLOT_EDITED':
      return { ...currentState, fetching: false };
    case 'CALL_SLOTS_DELETED':
      return { ...currentState, fetching: false };
    case 'FETCHING_CALL_SLOTS':
      return { ...currentState, fetching: true };
    case 'CALL_SLOTS_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
